import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'yakap-sidebar-collapsed'
const MOBILE_BREAKPOINT = 768

export default class extends Controller {
  static targets = ['sidebar', 'main', 'floatToggle', 'overlay', 'label', 'toggleIcon']

  #collapsed = false
  #mobileOpen = false
  #onResize = null

  connect() {
    this.#collapsed = localStorage.getItem(STORAGE_KEY) === 'true'
    if (!this.#isMobile() && this.#collapsed) this.applyCollapsed(true)
    delete document.documentElement.dataset.sidebarPreCollapsed

    this.#onResize = this.#handleResize.bind(this)
    window.addEventListener('resize', this.#onResize)
  }

  disconnect() {
    window.removeEventListener('resize', this.#onResize)
  }

  toggle() {
    if (this.#isMobile()) {
      this.#mobileOpen = !this.#mobileOpen
      this.#applyMobileOpen(this.#mobileOpen)
    } else {
      this.#collapsed = !this.#collapsed
      this.applyCollapsed(this.#collapsed)
      localStorage.setItem(STORAGE_KEY, this.#collapsed)
    }
  }

  applyCollapsed(collapsed) {
    this.sidebarTarget.classList.toggle('sidebar-collapsed', collapsed)
    if (this.hasMainTarget) {
      this.mainTarget.classList.toggle('pl-52', !collapsed)
      this.mainTarget.classList.toggle('pl-24', collapsed)
    }
    this.floatToggleTargets.forEach(el => {
      el.style.left = collapsed ? 'calc(4rem - 0.875rem)' : 'calc(12rem - 0.875rem)'
    })
    this.labelTargets.forEach(el => el.classList.toggle('hidden', collapsed))
    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.style.transform = collapsed ? 'rotate(180deg)' : ''
    }
  }

  #applyMobileOpen(open) {
    this.sidebarTarget.classList.toggle('mobile-open', open)
    if (this.hasOverlayTarget) this.overlayTarget.classList.toggle('hidden', !open)
    document.body.classList.toggle('overflow-hidden', open)
  }

  #isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT
  }

  #handleResize() {
    if (!this.#isMobile() && this.#mobileOpen) {
      this.#mobileOpen = false
      this.#applyMobileOpen(false)
    }
  }
}
